import React from 'react';
import { Navigate } from 'react-router-dom';

// Les groupes de catégories vivent dans la page Catégories, onglet « Groupes »
// (2026-09-27). L'ancienne adresse reste valable pour les favoris et le tour.
const CategoryGroups: React.FC = () => <Navigate to="/admin/categories?tab=groups" replace />;

export default CategoryGroups;
